import type { JSX } from 'react'
import IzzyGreetingsGif from '@/assets/images/izzy/greetings.gif'
import { cn } from '@/lib/utils'
import { IzzySpeechBubble } from '../speech-bubble'

interface IzzyCheckingProps {
  className?: string
  label: JSX.Element
}

export const IzzyGreeting = ({ className, label }: IzzyCheckingProps) => {
  return (
    <div className={cn('select-none', className)}>
      <img src={IzzyGreetingsGif} alt="Izzy dando boas vindas" />
      <div>
        <IzzySpeechBubble className="absolute w-60 left-40 bottom-38 flex flex-col gap-3">
          {label}
        </IzzySpeechBubble>
      </div>
    </div>
  )
}
